export enum ContextMenuListItemType {
	'Item',
	'Divider',
	'Group',
	'SubMenu'
}
